<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <div class="text-h3 mb-2" v-text="getTitle" />
      </v-col>
      <v-col v-if="!edit">
        <div class="d-flex justify-end">
          <v-btn color="primary" @click="editBundles">
            Редактировать
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <template v-if="!loading && !edit">
      <v-row>
        <v-col cols="12" md="7">
          <v-simple-table>
            <tbody>
              <tr>
                <td>Заголовок</td>
                <td>{{ getName }}</td>
              </tr>
              <tr>
                <td>Слаг</td>
                <td>{{ getSlug }}</td>
              </tr>
              <tr>
                <td>Категория</td>
                <td>{{ getCategoryId }}</td>
              </tr>
              <tr>
                <td>Описание</td>
                <td>{{ getDescription }}</td>
              </tr>
              <tr>
                <td>Тег заголовка</td>
                <td>{{ getH1 }}</td>
              </tr>
              <tr>
                <td>Мета заголовок</td>
                <td>{{ getMetaTitle }}</td>
              </tr>
              <tr>
                <td>Мета описание</td>
                <td>{{ getMetaDescription }}</td>
              </tr>
              <tr>
                <td>Цена</td>
                <td>{{ getPrice.formatted }}</td>
              </tr>
              <tr>
                <td>Старая цена</td>
                <td>{{ getOldPrice.formatted }}</td>
              </tr>
              <tr>
                <td>Бонусы</td>
                <td>{{ getBonusAdd }}</td>
              </tr>
              <tr>
                <td>Стикер</td>
                <td>{{ getStickerType }}</td>
              </tr>
              <tr>
                <td>Стикер маркетинг</td>
                <td>{{ getStickerMarketing }}</td>
              </tr>
              <tr>
                <td>Фото</td>
                <td>
                  <v-img
                    v-if="getImage"
                    max-width="100"
                    max-height="100"
                    :src="getImage"
                  />
                </td>
              </tr>
              <tr>
                <td>Индекс сортировки</td>
                <td>{{ getSortOrder }}</td>
              </tr>
              <tr>
                <td>Стоп лист</td>
                <td>{{ getHasStop ? 'Да' : 'Нет' }}</td>
              </tr>
              <tr>
                <td>Показывать в главном меню</td>
                <td>{{ getShowInMainMenu ? 'Да' : 'Нет' }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-container v-if="getItems">
            <v-row>
              <v-col
                v-for="(v, i) in getItems"
                cols="12"
                md="3"
                sm="6"
                :key="`collistinsinglecol-${i}`"
              >
                <v-card elevation="2">
                  <v-card-title>{{ v.name }}</v-card-title>
                  <v-card-actions>
                    <v-btn
                      text
                      color="orange accent-4"
                      @click="$router.push('/menuItems/' + v.id)"
                    >
                      Подробнее
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </template>
    <template v-else-if="!loading && edit">
      <v-row>
        <v-form>
          <v-container fluid>
            <v-row>
              <!-- Заголовок -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.name"
                  label="Заголовок"
                  outlined
                  required
                  :rules="rules.required"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Слаг -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.slug"
                  label="Слаг"
                  outlined
                  required
                  :rules="rules.required"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Категория -->
              <v-col cols="12" md="7">
                <v-select
                  v-model="data.categoryId"
                  :items="getCategoriesList"
                  item-text="name"
                  item-value="id"
                  outlined
                  label="Категория"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Описание -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.description"
                  label="Описание"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Тег заголовка -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.h1"
                  label="Тег заголовка"
                  outlined
                  required
                  :rules="rules.required"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Мета заголовок -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.metaTitle"
                  label="Мета заголовок"
                  outlined
                  required
                  :rules="rules.required"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Мета описание -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.metaDescription"
                  label="Мета описание"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Цена -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.price"
                  label="Цена"
                  outlined
                  required
                  :rules="[...rules.required, ...rules.number]"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Старая Цена -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.oldPrice"
                  label="Старая цена"
                  outlined
                  required
                  :rules="[...rules.required, ...rules.number]"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Бонусы -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.bonusAdd"
                  label="Бонусы"
                  outlined
                  required
                  :rules="[...rules.required, ...rules.number]"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Стикер -->
              <v-col cols="12" md="7">
                <v-select
                  v-model="data.stickerType"
                  item-text="text"
                  item-value="type"
                  :items="stickerType"
                  label="Стикер"
                  outlined
                />
              </v-col>
              <!-- Стикер Маркетинг -->
              <v-col cols="12" md="7">
                <v-select
                  v-model="data.stickerMarketing"
                  item-text="text"
                  item-value="type"
                  :items="stickerMarketing"
                  label="Стикер Маркетинг"
                  outlined
                />
              </v-col>
              <!-- Изображение -->
              <v-col cols="12" md="7">
                <upload-image
                  v-model="data.image"
                  color="orange"
                  label="Загрузить изображение набора"
                >
                  Загрузить изображение
                </upload-image>
              </v-col>
              <!-- Индекс сортировки -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.sortOrder"
                  label="Индекс сортировки"
                  outlined
                  required
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Стоп лист -->
              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.hasStop"
                  label="Стоп лист"
                  required
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- Показывать в главном меню -->
              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.showInMainMenu"
                  label="Показывать в главном меню"
                  required
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- Блюда в наборе -->
              <v-col md="7">
                <v-autocomplete
                  v-model="menuItems.model"
                  :items="getMenuItemsList"
                  item-text="name"
                  item-value="id"
                  outlined
                  chips
                  deletable-chips
                  multiple
                  label="Блюда в наборе"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <v-col cols="12" />
              <v-col
                md="3"
                v-for="(v, i) in menuItems.model"
                :key="`bundlmodif-${i}`"
              >
                <v-card>
                  <v-card-title>
                    <div class="text-h4 mb-2" v-text="v.name" />
                  </v-card-title>
                  <v-card-text>
                    <v-select
                      v-model="menuItems.data[i].modificationMenuItemId"
                      :items="getModificationsList"
                      label="Модификаторы:"
                      outlined
                      item-text="name"
                      item-value="id"
                      :disabled="loading"
                      :loading="loading"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <!-- Submit -->
              <v-col cols="12" md="7">
                <v-btn
                  class="mb-2"
                  block
                  color="primary"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                  @click.prevent="saveEdits"
                >
                  Сохранить
                </v-btn>
                <v-btn
                  block
                  :loading="loadingForm"
                  :disabled="loadingForm"
                  @click.prevent="$router.push('/bundles')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-row>
    </template>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        data: {},
        rules: {
          required: [(v) => !!v || 'Обязательное поле'],
          number: [(v) => !isNaN(Number(v)) || 'Только цифры'],
        },
        menuItems: {
          model: [],
          data: [],
        },
        stickerType: [
          { type: 'child', text: 'Для детей' },
          { type: 'spicy', text: 'Острое меню' },
          { type: 'vegetarian', text: 'Вегетарианское меню' },
        ],
        stickerMarketing: [
          { type: 'new', text: 'Новинка' },
          { type: 'hit', text: 'Хит' },
          { type: 'percent', text: 'Скидка' },
          { type: 'personalDiscount', text: 'Персональаня скидка' },
        ],
        edit: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarText: '',
      }
    },
    computed: {
      ...mapGetters({
        getBundlesSingle: 'bundles/getBundlesSingle',
        getCategoriesList: 'categories/getCategoriesList',
        getMenuItemsList: 'menuItems/getMenuItemsList',
        getModificationsList: 'modifications/getModificationsList',
      }),
      getId () {
        return this.$route.params.id || null
      },
      getName () {
        return this.getBundlesSingle ? this.getBundlesSingle.name : ''
      },
      getSlug () {
        return this.getBundlesSingle ? this.getBundlesSingle.slug : ''
      },
      getCategoryId () {
        return this.getBundlesSingle ? this.getBundlesSingle.category.name : ''
      },
      getDescription () {
        return this.getBundlesSingle ? this.getBundlesSingle.description : ''
      },
      getH1 () {
        return this.getBundlesSingle ? this.getBundlesSingle.h1 : ''
      },
      getMetaTitle () {
        return this.getBundlesSingle ? this.getBundlesSingle.metaTitle : ''
      },
      getMetaDescription () {
        return this.getBundlesSingle ? this.getBundlesSingle.metaDescription : ''
      },
      getPrice () {
        return this.getBundlesSingle ? this.getBundlesSingle.price.amount : ''
      },
      getOldPrice () {
        return this.getBundlesSingle ? this.getBundlesSingle.oldPrice.amount : ''
      },
      getBonusAdd () {
        return this.getBundlesSingle ? this.getBundlesSingle.bonusAdd : ''
      },
      getStickerType () {
        return this.getBundlesSingle ? this.getBundlesSingle.stickerType : ''
      },
      getStickerMarketing () {
        return this.getBundlesSingle ? this.getBundlesSingle.stickerMarketing : ''
      },
      getImage () {
        return this.getBundlesSingle ? this.getBundlesSingle.image : ''
      },
      getSortOrder () {
        return this.getBundlesSingle ? this.getBundlesSingle.sortOrder : 1
      },
      getStatus () {
        return this.getBundlesSingle ? this.getBundlesSingle.status : true
      },
      getHasStop () {
        return this.getBundlesSingle ? this.getBundlesSingle.hasStop : false
      },
      getShowInMainMenu () {
        return this.getBundlesSingle
          ? this.getBundlesSingle.showInMainMenu
          : false
      },
      getItems () {
        return this.getBundlesSingle ? this.getBundlesSingle.items : []
      },
      getTitle () {
        return this.edit
          ? `Редактирование набора: "${this.getName}"`
          : `Набор: "${this.getName}"`
      },
    },
    watch: {
      'menuItems.model' (newValue) {
        this.menuItems.data = newValue.map((v) => {
          return {
            id: v,
          }
        })
      },
    },
    async created () {
      if (this.getId) {
        this.loading = true
        await this.$store
          .dispatch('bundles/fetchSingleBundles', this.getId)
          .then((res) => {
            if (res.status === 200) {
              this.loading = false
            }
          })

        await this.$store.dispatch('categories/fetchCategoriesList', {
          limit: 10000,
          offset: 0,
          page: 1,
        })

        await this.$store.dispatch('menuItems/fetchMenuItemsList', {
          limit: 10000,
          offset: 0,
          page: 1,
        })

        await this.$store.dispatch('modifications/fetchModificationsList', {
          limit: 10000,
          offset: 0,
          page: 1,
        })

        if (this.$route.params.isedit) {
          this.editBundles()
        }
      } else {
        this.$router.push('/bundles')
      }
    },
    beforeDestroy () {
      this.$store.commit('bundles/clearBundlesSingle')
    },
    methods: {
      editBundles () {
        this.edit = true
        this.menuItems.model = this.getBundlesSingle
          ? this.getBundlesSingle.items.map((v) => v.id)
          : []
        this.data = {
          name: this.getBundlesSingle ? this.getBundlesSingle.name : '',
          slug: this.getBundlesSingle ? this.getBundlesSingle.slug : '',
          categoryId: this.getBundlesSingle
            ? this.getBundlesSingle.category.id
            : '',
          description: this.getBundlesSingle
            ? this.getBundlesSingle.description
            : '',
          h1: this.getBundlesSingle ? this.getBundlesSingle.h1 : '',
          metaTitle: this.getBundlesSingle ? this.getBundlesSingle.metaTitle : '',
          metaDescription: this.getBundlesSingle
            ? this.getBundlesSingle.metaDescription
            : '',
          price: this.getBundlesSingle ? this.getBundlesSingle.price.amount : '',
          oldPrice: this.getBundlesSingle
            ? this.getBundlesSingle.oldPrice.amount
            : '',
          bonusAdd: this.getBundlesSingle ? this.getBundlesSingle.bonusAdd : '',
          stickerType: this.getBundlesSingle
            ? this.getBundlesSingle.stickerType
            : '',
          stickerMarketing: this.getBundlesSingle
            ? this.getBundlesSingle.stickerMarketing
            : '',
          image: this.getBundlesSingle ? this.getBundlesSingle.image : '',
          sortOrder: this.getBundlesSingle ? this.getBundlesSingle.sortOrder : 1,
          status: this.getBundlesSingle ? this.getBundlesSingle.status : true,
          hasStop: this.getBundlesSingle ? this.getBundlesSingle.hasStop : false,
          showInMainMenu: this.getBundlesSingle
            ? this.getBundlesSingle.showInMainMenu
            : false,
          items: this.getBundlesSingle ? this.getBundlesSingle.items : [],
        }
      },
      saveEdits () {
        this.loadingForm = true
        this.data.items = this.menuItems.data
        this.$store
          .dispatch('bundles/editBundles', { data: this.data, id: this.getId })
          .then((res) => {
            if (res.status === 200) {
              this.edit = false
              this.snackbarText = 'Успешно обновлено!'
              this.snackbar = true
              this.data = null
              this.loadingForm = false
            }
          })
          .catch((err) => {
            this.loadingForm = false
            this.snackbarText = err.message
            this.snackbar = true
            console.log(err)
          })
      },
    },
  }
</script>
